<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="proposta.itens"
        hide-actions
        class="ma-0 w-100"
    >
      <template v-slot:items="nestedProps">
        <tr>
          <td>{{ nestedProps.item.codigoItem }}</td>
          <td>{{ nestedProps.item.sequencial }}</td>
          <td :title="nestedProps.item.descricao">{{ limitText(nestedProps.item.descricao, 50) }}</td>
          <td>{{ nestedProps.item.quantidade }}</td>
          <td class="input-small">
            <v-text-field v-if="proposta.aptoParaReadequacao" v-model="nestedProps.item.marca" maxlength="200"></v-text-field>
            <span v-else>{{ nestedProps.item.marca }}</span>
          </td>
          <td class="input-small">
            <v-text-field v-if="proposta.aptoParaReadequacao" v-model="nestedProps.item.modelo" maxlength="200"></v-text-field>
            <span v-else>{{ nestedProps.item.modelo || '-' }}</span>
          </td>
          <td style="text-align: right">
            <formatador-moeda :valor="nestedProps.item.valorUnitario || 0" :casas-decimais="casasDecimaisSemRegra"></formatador-moeda>
          </td>
          <td style="text-align: right" v-if="!isMaiorDesconto">
            <formatador-moeda :valor="nestedProps.item.valorTotal || 0" :casas-decimais="2"></formatador-moeda>
          </td>
          <td style="text-align: right">
            <div v-if="proposta.aptoParaReadequacao" style="text-align: right;" class="input-small">
              <campo-moeda :casas-decimais="casasDecimaisSemRegra"
                           v-model="nestedProps.item.valorUnitarioReadequado"
                           :menor-preco="!isMaiorDesconto"
                           @input="updateTotalReadequado(nestedProps.item); updatePropostaTotalReadequado(proposta)">
              </campo-moeda>
            </div>

            <formatador-moeda v-else
                              :valor="nestedProps.item.valorUnitarioReadequado || 0"
                              :casas-decimais="casasDecimaisSemRegra">
            </formatador-moeda>
          </td>
          <td style="text-align: right" v-if="!isMaiorDesconto">
            <formatador-moeda :valor="nestedProps.item.totalReadequado || 0" :casas-decimais="2"></formatador-moeda>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="mr-4 mb-4">
      <div class="footer-total">
          <span class="primary--text font-weight-bold">Total readequado:</span>
        <span v-if="isMaiorDesconto" :class=" classCSSValorTotalProposta(proposta)">
          <formatador-moeda :valor="proposta.valorTotalReadequado || 0" :casas-decimais="casasDecimais"></formatador-moeda> (%)
        </span>
        <span v-else-if="!isMaiorDesconto" :class=" classCSSValorTotalProposta(proposta)">
          R$ <formatador-moeda :valor="proposta.valorTotalReadequado || 0" :casas-decimais="casasDecimais"></formatador-moeda>
        </span>
      </div>
    </div>
    <div class="az-actions-form justify-end"  slot="actions" v-if="proposta.aptoParaReadequacao">
      <div class="align-right">
        <button class="action-primary" @click.prevent="$emit('enviar-readequacao', proposta)">ENVIAR READEQUACAO</button>
      </div>
    </div>
  </div>
</template>

<script>
import FormatadorMoeda from "@/commons/components/FormatadorMoeda.vue";
import CampoMoeda from "@/commons/components/CampoMoeda.vue";
import accounting from "accounting";
import {tiposDisputa} from "@/commons/constants";
import {mapState} from "vuex";

export default {
  components: {CampoMoeda, FormatadorMoeda},
  props: {
    proposta: Object,
    headers: Array,
    isMaiorDesconto: Boolean,
    isValorTotal: Boolean,
    tipoDisputa: String,
    exibirModalConfirmarEnvioReadequacao: {
      type: Boolean
    },
    casasDecimais: {
      type: Number,
      default: 2
    },
    casasDecimaisSemRegra: {
      type: Number
    }
  },
  data() {
    return {
      rawValue: 0,
      showBtns: false,
    };
  },
  computed:{
    isValorUnitario() {
      return tiposDisputa[this.licitacao.tipoDisputa] === tiposDisputa.VALOR_UNITARIO
    },
    ...mapState(['licitacao'])
  },
  methods: {
    limitText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      }
      return text;
    },

    updateTotalReadequado(item) {
      const casasDecimais = this.licitacao.casasDecimais
      if (this.isMaiorDesconto) {
        item.totalReadequado = Number(accounting.toFixed(accounting.unformat(item.valorUnitarioReadequado, ','), casasDecimais))
      } else {
        let preco = accounting.unformat(item.valorUnitarioReadequado, ',')
        const periodicidade = Number(item.periodicidade) > 0 ? Number(item.periodicidade) : 1
        item.totalReadequado = Number(accounting.toFixed(preco * item.quantidade * periodicidade, casasDecimais))
      }
    },

    classCSSValorTotalProposta(proposta) {
      if (proposta) {
        if(this.validarLoteUnificado(proposta)) return ''
        if (proposta.valorTotalReadequado <= 0) return ''

        if (this.isMaiorDesconto) {
          return Number(proposta.valorTotalReadequado.toFixed(this.casasDecimais)) < Number(proposta.valorTotalProposta.toFixed(this.casasDecimais)) ? 'vermelho' : ''
        } else {
          return Number(proposta.valorTotalReadequado.toFixed(this.casasDecimais)) > Number(proposta.valorTotalProposta.toFixed(this.casasDecimais)) ? 'vermelho' : ''
        }

      }
      
    },

    validarLoteUnificado(proposta){
      if(!proposta) return false
      return proposta.itens.find(item => item.isUnificado)
    },

    updatePropostaTotalReadequado(proposta) {
      if (this.isMaiorDesconto) {
        // Para maior desconto, soma todos os valores readequados dos itens
        let total = proposta.itens.reduce((total, item) => {
          const valorReadequado = accounting.unformat(item.valorUnitarioReadequado, ',') || 0;
          return total + valorReadequado;
        }, 0);

        proposta.valorTotalReadequado = total;
        return total;
      } else {
        // Lógica baseada no tipoDisputa
        let total = 0;

        if (this.tipoDisputa === 'VALOR_UNITARIO') {
          // Se tipoDisputa for "VALOR_UNITARIO", soma os valores unitários
          total = proposta.itens.reduce((total, item) => {
            const valorReadequado = accounting.unformat(item.valorUnitarioReadequado, ',') || 0;
            return total + valorReadequado;
          }, 0);
        } else if (this.tipoDisputa === 'VALOR_TOTAL') {
          // Se tipoDisputa for "VALOR_TOTAL", soma os valores totais (valor unitário * quantidade)
          total = proposta.itens.reduce((total, item) => {
            return total + (item.totalReadequado || 0);
          }, 0);
        } else {
          // Fallback para a lógica anterior se tipoDisputa não estiver definido
          total = proposta.itens.reduce((total, item) => {
            return total + (item.totalReadequado || 0);
          }, 0);
        }

        proposta.valorTotalReadequado = total;
        return total;
      }
    }
  }
};
</script>

<style>
.text-decoration-underline {
  text-decoration: underline;
}

.footer-total {
  display: block;
  margin-bottom: 5px;
  margin-top: 5px;
  text-align: end;
  width: 100%;
}

.vermelho {
  color: red;
}
</style>
